var $d89f977aee8885ad$exports = {};
$d89f977aee8885ad$exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Data selezionata non disponibile`,
            other: `Date selezionate non disponibili`
        })}.`
};


export {$d89f977aee8885ad$exports as default};
//# sourceMappingURL=it-IT.mjs.map
